document.addEventListener('DOMContentLoaded', function () {

  document.querySelectorAll('.hero-slideshow').forEach(function (slider) {
    const allSlides = Array.from(slider.querySelectorAll('.hero-slide'));
    const dots      = slider.querySelectorAll('.hero-dot');
    const duration  = parseInt(slider.dataset.duration) || 5000;

    // Returns only slides that are currently visible (respects hide-on-mobile)
    function getVisibleSlides() {
      return allSlides.filter(s => !s.classList.contains('hero-slide--hide-mobile') || window.innerWidth >= 768);
    }

    let slides = getVisibleSlides();
    let current = 0;
    let interval;

    if (slides.length === 0) return;
    if (slides.length === 1) { slides[0].classList.add('active'); return; }

    function showSlide(index) {
      slides.forEach((s, i) => {
        s.classList.toggle('active', i === index);
      });
      dots.forEach((d, i) => d?.classList.toggle('active', i === index));
      current = index;
    }

    function startSlider() {
      interval = setInterval(function () {
        showSlide((current + 1) % slides.length);
      }, duration);
    }

    function stopSlider() {
      clearInterval(interval);
    }

    // Dot navigation
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        stopSlider();
        showSlide(i);
        startSlider();
      });
    });

    slider.addEventListener('mouseenter', stopSlider);
    slider.addEventListener('mouseleave', startSlider);

    // Touch swipe
    let touchStartX = 0;
    slider.addEventListener('touchstart', function (e) {
      touchStartX = e.touches[0].clientX;
    }, { passive: true });
    slider.addEventListener('touchend', function (e) {
      const diff = touchStartX - e.changedTouches[0].clientX;
      if (Math.abs(diff) < 40) return;
      stopSlider();
      showSlide(diff > 0
        ? (current + 1) % slides.length
        : (current - 1 + slides.length) % slides.length
      );
      startSlider();
    }, { passive: true });

    // Re-evaluate visible slides on resize (mobile/desktop switch)
    window.addEventListener('resize', function () {
      stopSlider();
      slides = getVisibleSlides();
      if (!slides.includes(slides[current])) current = 0;
      showSlide(0);
      startSlider();
    });

    // Init
    showSlide(0);
    startSlider();
  });

});